import { Text, InputText, FileInfoCard } from '@pentabd/ui';

const SupportingDocuments = () => {
  return (
    <div>
      <div className="d-flex flex-column gap-9">
        <div className="row">
          <div className="col-3">
            <Text weight="semibold" size="sm" color="title">
              NOC Status
            </Text>
          </div>
          <div className="col-9">
            <InputText
              name="noc_status"
              placeholder="Enter NOC Status"
              disabled
            />
          </div>
        </div>
        <div className="row">
          <div className="col-3">
            <Text weight="semibold" size="sm" color="title">
              NOC Related Documents
            </Text>
          </div>
          <div className="col-9">
            <FileInfoCard title="Dashboard Recording.mp4" subtitle="16MB" />
          </div>
        </div>
        <div className="row">
          <div className="col-3">
            <Text weight="semibold" size="sm" color="title">
              Assent Handover List
            </Text>
          </div>
          <div className="col-9">
            <div className="border rounded mb-9 p-5">
              <ul>
                <li>Handover list</li>
                <li>Handover list2</li>
                <li>Handover list3</li>
              </ul>
            </div>
            <FileInfoCard title="Dashboard Recording.mp4" subtitle="16MB" />
          </div>
        </div>
        <div className="row">
          <div className="col-3">
            <Text weight="semibold" size="sm" color="title">
              Supporting Documents
            </Text>
          </div>
          <div className="col-9">
            <FileInfoCard title="Dashboard Recording.mp4" subtitle="16MB" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default SupportingDocuments;
